/**
 * clearLeadApi.js
 *
 * Provides an API call to clear lead data from the user's session.
 * Used when a user abandons or completes a registration flow.
 *
 * Exports:
 * - clearLead: Sends a request to clear the lead data.
 */

import { postTokenOnly } from "../shared/apiPatterns";

/**
 * Sends a request to clear the lead data.
 *
 * @returns {Promise<Object|null>} The API response JSON, or null on error.
 */
export const clearLead = () => postTokenOnly("/clear-lead");
